import { dom, library } from '@fortawesome/fontawesome-svg-core';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { html, css, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { svgWithJs, variables } from '../variables';

@customElement('apt-banner-with-button')
export class BannerWithButton extends LitElement {
  @property({ type: String })
  fontColorClass = 'font-black';
  @property({ type: String })
  backgroundClass = '';
  @property({ type: String })
  mainTitle = 'placeholder title';
  @property({ type: String })
  subTitle = 'placeholder subtitle';
  @property({ type: String })
  icon = 'fa-arrow-left';
  @property({ type: String })
  buttonText = 'placeholder btn text';

  static override get styles() {
    return [
      variables,
      svgWithJs,
      css`
        .font-white {
          color: var(--white);
        }

        .font-black {
          color: var(--black);
        }

        .flex-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border: 1px solid var(--border);
          padding: 0px 10px 0px 20px;
        }

        p {
          margin: -10px 0 0px 0px;
        }

        .bg-vizient-orange-muted {
          background-color: var(--vizient-orange-muted);
        }

        .title {
          font-size: 2rem;
        }

        .divider {
          font-size: 2.5rem;
          font-weight: lighter;
          margin: 0px 15px;
        }

        .sub-title {
          font-size: 1.5rem;
          font-weight: lighter;
        }

        button {
          width: 205px;
          height: 34px;
        }

        svg {
          margin-right: 10px;
        }
      `,
    ];
  }

  override render() {
    return html`
      <div
        class="flex-container ${this.backgroundClass} ${this.fontColorClass}"
      >
        <p>
          <span class="title">${this.mainTitle}</span>
          <span class="divider">|</span>
          <span class="sub-title">${this.subTitle}</span>
        </p>
        <button @click=${() => this.handleClick(this.buttonText)}>
          <i class="fa-solid ${this.icon}"></i>${this.buttonText}
        </button>
      </div>
    `;
  }

  private handleClick(buttonText: string) {
    this.dispatchEvent(
      new CustomEvent('ButtonClicked', {
        bubbles: true,
        detail: buttonText,
      }),
    );
  }

  protected override firstUpdated(): void {
    library.add(faArrowLeft);

    // @ts-ignore The dom.watch() TS definition indicates no parameters for this. However, when
    // you actually dig into the code, you see that it looks at the arguments after it gets into
    // the code and tries to pull some out if there aren't any (it even supplies an empty object
    // for options if you don't supply one yourself).
    //
    // Note: We have to wait for the first update for the shadow DOM to even be created.
    dom.watch({
      autoReplaceSvgRoot: this.shadowRoot,
      observeMutationsRoot: this.shadowRoot,
    });
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'apt-banner-with-button': BannerWithButton;
  }
}
